import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { initPlausible } from './lib/analytics'
import { initSentry } from './lib/sentry'
import './lib/pwaInstall'

initSentry()
initPlausible()

if (import.meta.env.PROD) {
  // Reload the page whenever a new service worker takes control (new build deployed).
  // The `refreshing` guard prevents a double-reload if both this listener and
  // workbox-window's `installed` handler fire for the same update.
  let refreshing = false
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true
      window.location.reload()
    }
  })

  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true })
  })

  // Poll for SW updates hourly so long-running sessions pick up new deploys.
  navigator.serviceWorker?.ready.then((registration) => {
    setInterval(() => { void registration.update() }, 60 * 60 * 1000)
  })
}

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div className="mx-auto min-h-dvh max-w-[430px] bg-stone-950 px-4 py-8 text-sm text-stone-300">
          <p className="font-semibold text-amber-200">Er ging iets mis</p>
          <p className="mt-2 text-stone-500">
            {error instanceof Error ? error.message : 'Onbekende fout'}
          </p>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
